<div #filterPanel class="filters-panel inverse-surface overlay" [class.expand-filters-panel]="filterExpanded">
    <div class="row justify-content-end m-1">
        <div class="col-7 align-self-center mat-font-title-md">
            Timeline Filter
        </div>
        <div class="col-2">
            <button matIconButton (click)="closePanel()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="row row-cols-2">
        <div class="static-col col">
            <div class="filter-title">Collection Type</div>
            <ng-container *ngFor="let modeType of filters.modeTypes">
                <div class="filter-line" [class.filter-empty]="enabled && empty(modeType)"
                     [class.filter-not-available]="!available(modeType)" matTooltip="{{getCheckboxTooltip(modeType)}}">
                    <mat-checkbox class="filter-checkbox"
                                  [class.checkbox-disabled]="enabled && (empty(modeType) || !available(modeType))"
                                  (change)="changeFilterValue('modeTypes',modeType.value, $event.checked)"
                                  [value]="modeType.value" [checked]="modeType.checked">{{ modeType.title }}
                    </mat-checkbox>

                </div>
            </ng-container>
            <div class="filter-title">GSD (Resolution)</div>
            <ng-container *ngFor="let resolution of filters.resolutions">
                <div class="filter-line" [class.filter-empty]="enabled && empty(resolution)"
                     [class.filter-not-available]="!available(resolution)"
                     matTooltip="{{getCheckboxTooltip(resolution)}}">
                    <mat-checkbox class="filter-checkbox"
                                  [class.checkbox-disabled]="enabled && (empty(resolution) || !available(resolution))"
                                  (change)="changeFilterValue('resolutions',resolution.value, $event.checked)"
                                  [value]="resolution.value" [checked]="resolution.checked">{{ resolution.title }}
                    </mat-checkbox>
                </div>
            </ng-container>
            <div class="filter-title">Ortho Status</div>
            <ng-container *ngFor="let status of filters.orthoStatus">
                <div class="filter-line" [class.filter-empty]="enabled && empty(status)"
                     [class.filter-not-available]="!available(status)" matTooltip="{{getCheckboxTooltip(status)}}">
                    <mat-checkbox class="filter-checkbox"
                                  [class.checkbox-disabled]="enabled && (empty(status) || !available(status))"
                                  (change)="changeFilterValue('orthoStatus',status.value, $event.checked)"
                                  [value]="status.value" [checked]="status.checked">{{ status.title }}
                    </mat-checkbox>
                </div>
            </ng-container>
        </div>
        <div class="col" [class.col-expanded]=filterExpanded>
            <div class="filter-title">Imagery Type</div>
            <ng-container *ngFor="let imageryType of filters.imageryTypes">
                <mat-icon *ngIf="grayskyAvailable?.length > 0 && imageryType.value === 'graysky'" class="left-mat-icon"
                          (click)="imageryType.cardExpanded = !imageryType.cardExpanded ; filterExpanded = imageryType.cardExpanded">
                    {{ imageryType.cardExpanded ? 'arrow_drop_down' : 'arrow_right' }}
                </mat-icon>
                <div class="filter-line" [class.filter-empty]="enabled && empty(imageryType)"
                     [class.filter-not-available]="!available(imageryType)"
                     matTooltip="{{getCheckboxTooltip(imageryType)}}">
                    <mat-checkbox class="filter-checkbox"
                                  [class.checkbox-disabled]="enabled && (empty(imageryType) || !available(imageryType))"
                                  (change)="changeFilterValue('imageryTypes',imageryType.value, $event.checked)"
                                  [value]="imageryType.value" [checked]="imageryType.checked">{{ imageryType.title }}
                    </mat-checkbox>
                </div>
                <div *ngIf="imageryType.cardExpanded && imageryType.value === 'graysky'" class="filter-aois">
                    <ng-container *ngFor="let aoi of grayskyAvailable">
                        <span class="aoi-child-container"
                              matTooltip="{{!available(imageryType) ? 'Correlated attribute checked off' : null}}">
                            <mat-checkbox class="filter-checkbox aoi"
                                          [class.checkbox-disabled]="enabled && (empty(imageryType) || !available(imageryType))"
                                          [class.filter-empty]="enabled && empty(imageryType)"
                                          (change)="changeVisibilityAoi(imageryType, aoi, $event.checked)"
                                          [checked]="aoi.isVisible()"><!--{{aoi.getParentPrettyName()}} -->{{ aoi.getPrettyName() }}</mat-checkbox>
                        </span>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</div>
